import { ComponentPropsWithoutRef, ForwardedRef, forwardRef } from "react"
import { SLabel } from "../../acquisitionForm/AcquisitionForm.styled"
import { Div } from "../../../../../components/div/Div"
import { styled, theme } from "../../../../../styles/stitches.config"

function FormLabelInner(
  { children, ...props }: ComponentPropsWithoutRef<typeof SLabel>,
  ref: ForwardedRef<HTMLLabelElement>
) {
  return (
    <SLabel ref={ref} {...props}>
      {children}
    </SLabel>
  )
}

function FormItemInner(
  { children, ...props }: ComponentPropsWithoutRef<typeof Div>,
  ref: ForwardedRef<HTMLDivElement>
) {
  return (
    <Div ref={ref} {...props}>
      {children}
    </Div>
  )
}

const FormError = styled("p", {
  color: theme.colors.errors,
  paddingRight: theme.space.s3,
  fontSize: theme.sizes.s2_5,
  whiteSpace: "nowrap",

  variants: {
    align: {
      start: { textAlign: "start" },
    },
    end: {
      true: { textAlign: "end" },
    },
  },

  defaultVariants: {
    align: "end",
  },
})

const FormLabel = forwardRef(FormLabelInner)
const FormItem = forwardRef(FormItemInner)

export { FormItem, FormLabel, FormError }
